export const depositBaseHref = '/vklady/';
